import React from 'react';
import getCheckboxField from '../../fields/checkbox';
import getSelectField from '../../fields/select';
import getFonts from '../../../Functions/config/fonts';
import { HexAlphaColorPicker, HexColorInput } from "react-colorful";

const Header = (props) => {
    const { widget, handleInputChange, toggleColorPicker, setColorsAndPreview } = props;
    const { rentvine } = widget.htmlData;
    const fontOptions = getFonts();

    const setColorsAndPreviewHandler = async (type, color) => {
        await setColorsAndPreview('header', type, color);
    };

    const setHeaderColor = async (color) => {
        await setColorsAndPreviewHandler('headercolor', color);
    };

    const setHeaderBg = async (color) => {
        await setColorsAndPreviewHandler('headerbg', color);
    };

    return (
        <div className="mjwi-acc-panel-wrapper">
            <label htmlFor="rentvineHeading">Heading:</label>
            <input
                type="text"
                name="rentvineHeading"
                value={rentvine.header.rentvineHeading}
                onChange={handleInputChange}
            />

            <div className='mjwi-row'>    
                <div className='mjwi-col33'>
                    <label>Font Family</label>                                    
                </div>
                <div className='mjwi-col66'>
                    {getSelectField('headerFontFamily', fontOptions, rentvine.header.headerFontFamily, handleInputChange)}
                </div>
            </div>

            <div className='mjwi-row'>    
                <div className='mjwi-col33 mjwi-row'>
                    <label htmlFor="headerFontSize">Size</label>&nbsp;
                    <input
                        type="number"
                        name="headerFontSize"
                        value={rentvine.header.headerFontSize}
                        onChange={handleInputChange}
                    />&nbsp;px
                </div>
                <div className='mjwi-col25'>
                    <label>
                        {getCheckboxField('headerFontBold', rentvine.header.headerFontBold, handleInputChange)}
                        Bold
                    </label>                                  
                </div>
                <div className='mjwi-col25'>
                    <label>
                        {getCheckboxField('headerFontItalic', rentvine.header.headerFontItalic, handleInputChange)}
                        Italic
                    </label>                                  
                </div>                          
            </div>

            <div className='mjwi-row'>
                <div className='mjwi-col33'>
                    <label>Color</label>
                </div>
                <div className='mjwi-col66 mjwi-clr-picker'>
                    <span className="clrPickerVal" onClick={toggleColorPicker} style={{ backgroundColor: rentvine.header.headercolor }}></span>
                    <HexAlphaColorPicker color={rentvine.header.headercolor} onChange={setHeaderColor} style={{display: "none"}} className="mjwi-apfl-color-picker" />
                    <HexColorInput color={rentvine.header.headercolor} onChange={setHeaderColor} />
                </div>
            </div>

            <div className='mjwi-row'>
                <div className='mjwi-col33'>
                    <label>Background</label>
                </div>
                <div className='mjwi-col66 mjwi-clr-picker'>
                    <span className="clrPickerVal" onClick={toggleColorPicker} style={{ backgroundColor: rentvine.header.headerbg }}></span>
                    <HexAlphaColorPicker color={rentvine.header.headerbg} onChange={setHeaderBg} style={{display: "none"}} className="mjwi-apfl-color-picker" />
                    <HexColorInput color={rentvine.header.headerbg} onChange={setHeaderBg} />
                </div>
            </div>

            <div className='mjwi-row'>
                <div className='mjwi-col100'>
                    <label htmlFor="rentvineHeading">Show/Hide Filters</label>
                </div>
            </div>
            <div className="mjwi-apfl-display-filters">
                <div className='mjwi-row'>
                    <div className='mjwi-col33'>
                        <label>
                            {getCheckboxField('search', rentvine.rentvineDisplayFilters.search, handleInputChange)}
                            Search
                        </label>                                    
                    </div>
                    <div className='mjwi-col33'>
                        <label>
                            {getCheckboxField('minRent', rentvine.rentvineDisplayFilters.minRent, handleInputChange)}
                            Min Rent
                        </label>
                    </div>
                    <div className='mjwi-col33'>
                        <label>
                            {getCheckboxField('maxRent', rentvine.rentvineDisplayFilters.maxRent, handleInputChange)}
                            Max Rent
                        </label>
                    </div>
                </div>
                <div className='mjwi-row'>
                    <div className='mjwi-col33'>
                        <label>
                            {getCheckboxField('beds', rentvine.rentvineDisplayFilters.beds, handleInputChange)}
                            Beds
                        </label>
                    </div>
                    <div className='mjwi-col33'>
                        <label>
                            {getCheckboxField('baths', rentvine.rentvineDisplayFilters.baths, handleInputChange)}
                            Baths
                        </label>
                    </div>
                    <div className='mjwi-col33'>
                        <label>
                            {getCheckboxField('cities', rentvine.rentvineDisplayFilters.cities, handleInputChange)}
                            Cities
                        </label>
                    </div>
                </div>
                <div className='mjwi-row'>
                    <div className='mjwi-col33'>
                        <label>
                            {getCheckboxField('zip', rentvine.rentvineDisplayFilters.zip, handleInputChange)}
                            Zip
                        </label>
                    </div>
                    <div className='mjwi-col33'>
                        <label>
                            {getCheckboxField('cats', rentvine.rentvineDisplayFilters.cats, handleInputChange)}
                            Cats
                        </label>
                    </div>
                    <div className='mjwi-col33'>
                        <label>
                            {getCheckboxField('dogs', rentvine.rentvineDisplayFilters.dogs, handleInputChange)}
                            Dogs
                        </label>
                    </div>
                </div>
                <div className='mjwi-row'>
                    <div className='mjwi-col33'>
                        <label>
                            {getCheckboxField('sorting', rentvine.rentvineDisplayFilters.sorting, handleInputChange)}
                            Sorting
                        </label>
                    </div>
                    <div className='mjwi-col33'>
                        <label>
                            {getCheckboxField('desiredMoveIn', rentvine.rentvineDisplayFilters.desiredMoveIn, handleInputChange)}
                            Move-In
                        </label>
                    </div>
                    <div className='mjwi-col33'>
                    </div>
                </div>
            </div>

            <div className='mjwi-row'>
                <div className='mjwi-col33'>
                    <label>Sort order</label>
                </div>
                <div className='mjwi-col66'>
                    <select
                        id="rentvineSortOrder"
                        name="rentvineSortOrder"
                        value={rentvine.rentvineSortOrder}
                        onChange={handleInputChange}
                    >
                        <option value="date_posted">Most Recent</option>
                        <option value="rent_asc">Rent (Low to High)</option>
                        <option value="rent_desc">Rent (High to Low)</option>
                        <option value="bedrooms_asc">Bedrooms (ASC)</option>
                        <option value="bedrooms_desc">Bedrooms (DESC)</option>
                        <option value="availability">Availability</option>
                    </select>
                </div>
            </div>
        </div>
    );
};

export default Header;